export default __webpack_public_path__ + "locales/tr/Ldap.json?hash=269177fe7fa156144f897548a5d6346d";